import { Label } from "@/components/ui/Input";
import {
  INBOUND_SUBCONTAINER_UNIT_KIND_TILE_KINDS,
  inboundArrivalUnitKindTileLabel,
  type InboundArrivalUnitKind,
} from "@/pages/shipping/inboundArrivalUnitKind";

export function InventoryBoxUnitKindSelect({
  id,
  label,
  value,
  onChange,
  disabled,
}: {
  id: string;
  label: string;
  value: InboundArrivalUnitKind;
  onChange: (kind: InboundArrivalUnitKind) => void;
  disabled?: boolean;
}): JSX.Element {
  return (
    <div>
      <Label htmlFor={id}>{label}</Label>
      <select
        id={id}
        className="mt-1 block h-10 w-full rounded-md border border-slate-300 bg-white px-3 text-sm text-slate-900 focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500 disabled:cursor-not-allowed disabled:opacity-60"
        value={value}
        disabled={disabled}
        onChange={(event) => onChange(event.target.value as InboundArrivalUnitKind)}
      >
        {INBOUND_SUBCONTAINER_UNIT_KIND_TILE_KINDS.map((kind) => (
          <option key={kind} value={kind}>
            {inboundArrivalUnitKindTileLabel(kind)}
          </option>
        ))}
      </select>
    </div>
  );
}
